import {Team as BaseTeam, UserTeamAssignment} from "@irati/types"

export interface TeamWithHierarchy extends BaseTeam {
  children: TeamWithHierarchy[],
  isLeader: boolean
}

interface Teams {
  rootTeam: TeamWithHierarchy,
  leaderOf: TeamWithHierarchy[]
}

type teamHierarchy = () => Teams

export default function teamHierarchy(original: BaseTeam[], assignments: UserTeamAssignment[]) {
  // clone
  const teams: TeamWithHierarchy[] = JSON.parse(JSON.stringify(original))

  const rootTeam = teams.find((team) => team.parentId === "")
  if (!rootTeam) {
    throw new Error()
  }

  return attachChildTeams(rootTeam, teams, assignments, [])
}

function attachChildTeams(
  parent: TeamWithHierarchy,
  teams: TeamWithHierarchy[],
  assignments: UserTeamAssignment[],
  leaderOf: TeamWithHierarchy[]
): Teams {
  parent.children = teams.filter((test) => test.parentId === parent.uuid)
  parent.isLeader = parent.isLeader || !!assignments.find(({teamId}) => teamId === parent.uuid)
  if (parent.isLeader) {
    leaderOf.push(parent)
  }

  parent.children.forEach((child) => {
    child.isLeader = parent.isLeader
    attachChildTeams(child, teams, assignments, leaderOf)
  })

  return {rootTeam: parent, leaderOf}
}
